import src from "IMAGE";
export default { src, width: 971, height: 236, blurWidth: 0, blurHeight: 0};
